import type { Item } from '@easymoving/types';
import { needsDecision } from './needs';

export interface RoomProgress {
  /** room value (default key or custom string), or '' for items with no room. */
  room: string;
  total: number;
  packed: number;
  needsDecision: number;
}

/** Per-room completion (PRD §10.3). Sorted by item count desc, no-room last. */
export function computeRoomProgress(items: Item[]): RoomProgress[] {
  const map = new Map<string, RoomProgress>();
  for (const it of items) {
    const room = it.room ?? '';
    const r = map.get(room) ?? { room, total: 0, packed: 0, needsDecision: 0 };
    r.total += 1;
    if (it.progressStatus === 'packed') r.packed += 1;
    if (needsDecision(it)) r.needsDecision += 1;
    map.set(room, r);
  }
  return [...map.values()].sort((a, b) => {
    if (a.room === '') return 1;
    if (b.room === '') return -1;
    return b.total - a.total;
  });
}
